import React from "react";
import { motion } from "framer-motion";
import { useTheme } from "@/contexts/ThemeContext";

/**
 * Animazione di caricamento a tema "rete" — nodo hub centrale che pulsa dati
 * verso 3 nodi satellite (coerente col logomark TotalKlickLogo). Usata per le
 * fasi senza percentuale nota (calcolo diff, applicazione import).
 *
 * Disponibile in 2 varianti cromatiche: "dark" (su glass-card scure) e
 * "light" (su superfici chiare). Se `variant` non e' passato, si adatta
 * automaticamente al ThemeContext globale.
 */
const NODES = [
  { x: 60, y: 14 },   // alto
  { x: 22, y: 78 },   // basso-sx
  { x: 98, y: 78 },   // basso-dx
];
const HUB = { x: 60, y: 54 };

export default function NetworkLoader({ variant, size = 96, label }) {
  const ctx = useTheme();
  const isDark = variant ? variant === "dark" : !!ctx?.isDark;

  const lineColor = isDark ? "#E8A978" : "#C25934";
  const hubFill = isDark ? "#FFFFFF" : "#C25934";
  const nodeFill = isDark ? "#F2B98A" : "#9B3F23";
  const labelColor = isDark ? "text-zinc-400" : "text-zinc-500";

  return (
    <div className="flex flex-col items-center gap-3" data-testid="network-loader">
      <svg width={size} height={size} viewBox="0 0 120 92" fill="none" xmlns="http://www.w3.org/2000/svg">
        {NODES.map((n, i) => (
          <motion.line
            key={`line-${i}`}
            x1={HUB.x} y1={HUB.y} x2={n.x} y2={n.y}
            stroke={lineColor} strokeWidth={isDark ? 2 : 1.8} strokeLinecap="round"
            initial={{ pathLength: 0, opacity: 0 }}
            animate={{ pathLength: [0, 1, 1, 0], opacity: [0, 1, 1, 0] }}
            transition={{ duration: 2.1, repeat: Infinity, ease: "easeInOut", times: [0, 0.35, 0.75, 1], delay: i * 0.22 }}
          />
        ))}
        {NODES.map((n, i) => (
          <motion.circle
            key={`node-${i}`}
            cx={n.x} cy={n.y} r={6.5} fill={nodeFill}
            initial={{ opacity: 0, scale: 0.4 }}
            animate={{ opacity: [0, 1, 1, 0], scale: [0.4, 1, 1, 0.4] }}
            transition={{ duration: 2.1, repeat: Infinity, ease: "easeInOut", times: [0, 0.4, 0.8, 1], delay: i * 0.22 }}
            style={{ transformOrigin: `${n.x}px ${n.y}px` }}
          />
        ))}
        <motion.circle
          cx={HUB.x} cy={HUB.y} r={10} fill={hubFill}
          animate={{ scale: [1, 1.12, 1], opacity: [0.85, 1, 0.85] }}
          transition={{ duration: 1.3, repeat: Infinity, ease: "easeInOut" }}
          style={{ transformOrigin: `${HUB.x}px ${HUB.y}px` }}
        />
      </svg>
      {label && <div className={`text-xs ${labelColor}`}>{label}</div>}
    </div>
  );
}
